export class HydrographColors {
  static LIGHT_GREEN = '#99ff99';
  static LIGHTER_YELLOW = '#ffea9a';
  static LIGHT_ORANGE = '#ffcb93';
  static LIGHT_RED = '#ff9999';
  static LIGHT_PURPLE = '#d699ff';
}